"use client"
import Icon from '@components/icon'
import Logo from '@components/station/logo'
import { useStorage } from '@hooks'
import Link from 'next/link'
import React, { useMemo } from 'react'
import styles from './category.module.scss'
import { IStation } from '@models'
import { STATION_FULL_NAME } from '@lib/helpers'

export default function Favorites({allStations}: {allStations: IStation[]}) {
    const { get } = useStorage("favorites")
    const stations = useMemo(() => {
        const favorites = (get() || []) as string[]
        return allStations.filter(station => favorites.includes(station.id))
    }, [allStations])

    if (!stations.length) return (
        <div className={styles.noFavorites}>
            <Icon icon={['fas', 'heart']} />
            <h1>אין עדיין תחנות מועדפות</h1>
            <h2>סמנו ״הוספה למועדפים״ בתחנות הרדיו ותוכלו לגשת אליהן בצורה מהירה בעתיד מכל מקום באתר</h2>
        </div>
    )
    return (
        <nav className={`${styles.nav} animated-slow`}>
            {
                stations.map(station => (
                    <Link href={`/station/${station.id}`} key={station.id}>
                      <div>
                        <Logo station={station} />
                      </div>
                      <span>{STATION_FULL_NAME(station.name)}</span>
                    </Link>
                  ))
            }
        </nav>
    )
}